/* eslint-disable func-names */
import { get } from "lodash";
import { Event, EnrichmentPlugin } from "@amplitude/analytics-types";
import * as amplitude from "@amplitude/marketing-analytics-browser";

import {
  ExtraPropertiesArgs,
  GetGlobalProperties,
  GlobalProperties,
  PathnameHashAndSearch
} from "./types";
import {
  COMMON_EVENT_NAMES,
  TVG_PAGE_CONFIG,
  USE_OLD_PATHS
} from "./constants";
import { getPageName, getPageViewVal } from "./utils";

export default (
  getGlobalProperties: GetGlobalProperties,
  pagesConfig = TVG_PAGE_CONFIG,
  extra?: ExtraPropertiesArgs
) => {
  const name = "global-properties-plugin";
  const type = amplitude.Types.PluginType.ENRICHMENT;
  const setup = async function () {
    // initial setup here!
  };

  // The following function will "intercept" every event being triggered
  // and will append the "global properties" to every event
  const execute = async function (event: Event) {
    const globalProperties =
      typeof getGlobalProperties === "function" && getGlobalProperties();
    if (globalProperties) {
      event.event_properties ||= {};
      event.event_properties = {
        ...event.event_properties,
        ...globalProperties
      };
    }

    if (event.event_type === COMMON_EVENT_NAMES.PAGE_VIEWED) {
      const pageName = get(
        event.event_properties,
        GlobalProperties.PAGE_NAME,
        getPageName(window.location, pagesConfig)
      );

      event.event_type = getPageViewVal(pageName);
    }

    if (
      event.event_type === COMMON_EVENT_NAMES.NAVIGATED &&
      extra?.prevPath.current &&
      USE_OLD_PATHS.includes(extra.prevPath.current)
    ) {
      const prevPath = extra.prevPath.current ?? "";

      const fullUrl: string = get(
        event.event_properties,
        GlobalProperties.FULL_URL,
        ""
      );
      const ogPath: string = get(
        event.event_properties,
        GlobalProperties.PAGE_PATH,
        ""
      );
      const newFullUrl = fullUrl.replace(ogPath, prevPath);

      event.event_properties = {
        ...event.event_properties,
        [GlobalProperties.FULL_URL]: newFullUrl,
        [GlobalProperties.PAGE_PATH]: prevPath,
        [GlobalProperties.PAGE_NAME]: getPageName(
          { pathname: prevPath } as PathnameHashAndSearch,
          pagesConfig
        )
      };
    }

    return event;
  };

  const plugin: EnrichmentPlugin = {
    name,
    setup,
    type,
    execute
  };

  return plugin;
};
